export const fileUtils = {
  // Создание URL для скачивания файла
  createDownloadUrl: (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  },

  // Создание URL для предпросмотра
  createPreviewUrl: (blob) => {
    return window.URL.createObjectURL(blob);
  },

  // Форматирование размера файла
  formatFileSize: (bytes) => {
    if (!bytes || bytes === 0) return '0 B';
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
  },

  // Проверка размера файла
  isValidFileSize: (file, maxSizeMB = 10) => {
    const maxSize = maxSizeMB * 1024 * 1024;
    return file.size <= maxSize;
  },

  // Получение расширения файла
  getFileExtension: (filename) => {
    return filename.split('.').pop()?.toLowerCase() || '';
  },

  // Проверка типа файла
  isValidFileType: (file, allowedTypes = []) => {
    if (allowedTypes.length === 0) return true;
    
    const extension = fileUtils.getFileExtension(file.name);
    const mimeType = file.type;
    
    return allowedTypes.some(type => 
      mimeType.includes(type) || extension === type
    );
  },

  // Безопасное преобразование FileList в массив
  fileListToArray: (fileList) => {
    if (!fileList) return [];
    return Array.from(fileList);
  },

  // Определение типа файла по MIME type
  getFileType: (mimeType, fileName = '') => {
    if (!mimeType && !fileName) return 'unknown';
    
    const name = fileName.toLowerCase();
    const type = mimeType ? mimeType.toLowerCase() : '';

    if (type.includes('pdf') || name.endsWith('.pdf')) return 'pdf';
    if (type.includes('word') || name.match(/\.docx?$/)) return 'word';
    if (type.includes('excel') || type.includes('spreadsheet') || name.match(/\.xlsx?$/)) return 'excel';
    if (type.includes('csv') || name.endsWith('.csv')) return 'csv';
    if (type.includes('powerpoint') || name.match(/\.pptx?$/)) return 'powerpoint';
    if (type.includes('image')) return 'image';
    if (type.includes('text')) return 'text';
    if (type.includes('zip') || type.includes('compressed') || name.match(/\.(zip|rar|7z|tar|gz)$/)) return 'archive';
    return 'document';
  }
};

export const apiUtils = {
  // Обработка ошибок API
  handleApiError: (error, defaultMessage = 'Произошла ошибка') => {
    if (error.message.includes('Network Error')) {
      return 'Ошибка сети. Проверьте подключение к интернету.';
    }
    
    if (error.message.includes('401')) return 'Неавторизованный доступ.';
    if (error.message.includes('403')) return 'Доступ запрещен.';
    if (error.message.includes('404')) return 'Ресурс не найден.';
    if (error.message.includes('500')) return 'Внутренняя ошибка сервера.';
    
    return error.message || defaultMessage;
  },

  // Создание query string из объекта
  buildQueryString: (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        searchParams.append(key, params[key]);
      }
    });
    return searchParams.toString();
  },

  // Извлечение отделов из пользователей
  extractDepartments: (users) => {
    if (!users || !Array.isArray(users)) return [];
    const departments = new Set();
    users.forEach(user => {
      if (user.department && user.department.trim()) {
        departments.add(user.department.trim());
      }
    });
    return Array.from(departments).sort();
  }
};